/* eslint-disable max-lines-per-function */
import "./naming-benefits-modal.scss";
import { EventBus, Events, store } from "jiffy-store";
import { api } from "jiffy-api";

import triggerCongratsModal from "components/jiffy/saved-carts-name-congrats-modal/saved-carts-name-congrats-modal";
import { changeCartName } from "components/jiffy/masthead-cart/masthead-cart";
import { track } from "jiffy-analytics";

const SELECTORS = {
  MODAL: ".js-naming-benefits-modal",
  MODAL_CLOSE: ".js-naming-benefits-modal-close",
  DROPDOWN: ".js-qty-form-saved-carts-input",
  FORM: ".js-rename-modal-form",
  SUBMIT: ".js-rename-modal-submit",
  INPUT: ".js-naming-benefits-modal-input",
  NAME_INPUT: ".js-naming-benefits-modal-input-name"
};

const PLACEHOLDERS = {
  cartName: "Name this cart",
  notes: "Add some notes"
};

const FORM_CLASSES = {
  invalidInput: "naming-benefits-modal__input--invalid",
  invalidLabel: "naming-benefits-modal__label--invalid"
};

const shouldShowModal = activeCart => {
  const cookie = document.cookie
    .split(";")
    .find(elem => elem.split("=")[0].trim() === "renameCtaShown");

  if (cookie) return false;

  if (!activeCart.cart_name.startsWith(activeCart.default_cart_name)) {
    return false;
  }

  return true;
};

async function saveCartChanges(modal, jsonData, orderNumber) {
  const response = await api.jiffyshirts.savedCart.update(
    { id: orderNumber },
    { saved_carts: jsonData }
  );
  modal.modal("hide");
  triggerCongratsModal(response.cart_name);

  // eslint-disable-next-line no-undef
  EventBus.publish(Events.SAVED_CART_CHANGED, this, {
    cartNumber: orderNumber,
    newName: response.cart_name
  });

  changeCartName(orderNumber, response.cart_name);

  track("saved_carts_naming_cta_modal_saved");
}

const inputHandler = ({ target: $target }) => {
  const $submitButton = document.querySelector(SELECTORS.SUBMIT);
  if (!($target instanceof HTMLElement)) return;

  if ($target.value === "") {
    $submitButton.classList.add("disabled");
    $target.placeholder = "";
    $target.classList.add(FORM_CLASSES.invalidInput);
    $target.nextElementSibling.classList.add(FORM_CLASSES.invalidLabel);
  } else {
    $submitButton.classList.remove("disabled");
    $target.placeholder = PLACEHOLDERS.cartName;
    $target.classList.remove(FORM_CLASSES.invalidInput);
    $target.nextElementSibling.classList.remove(FORM_CLASSES.invalidLabel);
  }
};

export default wrapper => {
  const $dropdown = wrapper.querySelector(SELECTORS.DROPDOWN);
  const $modal = document.querySelector(SELECTORS.MODAL);
  const $closeBtn = document.querySelectorAll(SELECTORS.MODAL_CLOSE);
  const $form = document.querySelector(SELECTORS.FORM);
  const $inputs = document.querySelectorAll(SELECTORS.INPUT);
  const $nameInput = document.querySelector(SELECTORS.NAME_INPUT);
  const $submitButton = document.querySelector(SELECTORS.SUBMIT);
  const $$modal = $($modal);

  if (!$modal) return;

  $dropdown.addEventListener("click", () => {
    const activeCart = store.get(state => state.pdp.activeCart);
    if (!shouldShowModal(activeCart)) return;

    $$modal.modal("show");

    document.cookie = "renameCtaShown=1";
    track("saved_carts_naming_cta_modal_opened");
  });

  $form.addEventListener("submit", evt => {
    evt.preventDefault();

    const orderNumber = store.get(state => state.pdp.activeCart).number;
    const jsonData = {};

    $inputs.forEach(input => {
      jsonData[input.id] = input.value;
    });

    saveCartChanges($$modal, jsonData, orderNumber);
  });

  $closeBtn.forEach(btn => {
    btn.addEventListener("click", () => {
      $$modal.modal("hide");
      $form.reset();
    });
  });

  $inputs.forEach($input => {
    $input.addEventListener("blur", () => {
      track("saved_carts_naming_cta_modal_input", { field: $input.id });
    });
  });

  $nameInput.addEventListener("blur", ({ target }) => {
    inputHandler({ target });
  });

  $$modal.on("shown.bs.modal", () => {
    $inputs.forEach($input => {
      if ($input.id === $nameInput.id) {
        $input.focus();
        $input.placeholder = PLACEHOLDERS.cartName;
        $input.classList.remove(FORM_CLASSES.invalidInput);
        $input.nextElementSibling.classList.remove(FORM_CLASSES.invalidLabel);
        $submitButton.classList.remove("disabled");
      } else if ($input.id === "notes-control") {
        $input.placeholder = PLACEHOLDERS.notes;
      }
    });
  });

  $$modal.on("hide.bs.modal", event => {
    event.stopPropagation();

    if ($$modal.is(":visible")) {
      track("saved_carts_naming_cta_modal_dismissed");
    }
  });
};
